import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import values from 'lodash/values';
import noop from 'lodash/noop';

import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './Message.css';
import { uiTypes } from './Message.config';
import { messageTypes, messageTypeIconMapping } from '../Messages.config';

const cx = classNames.bind(styles);

export default class Message extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        type: PropTypes.oneOf(values(messageTypes)),
        uiType: PropTypes.oneOf(values(uiTypes)),
        title: PropTypes.string,
        children: PropTypes.element,
        hasClose: PropTypes.bool,
        onClose: PropTypes.func,
        className: PropTypes.string,
        renderAsHTML: PropTypes.bool,
    };

    static defaultProps = {
        id: '',
        type: messageTypes.information,
        uiType: uiTypes?.box,
        title: '',
        children: null,
        hasClose: true,
        onClose: noop,
        className: '',
        renderAsHTML: false,
    };

    /**
     * Renders the basic outer skeleton required to render the message box
     * @return {ReactComponent}
     */
    render() {
        const { id, type, uiType, title, children, className, hasClose, renderAsHTML } = this.props;

        return (
            <div
                id={id}
                className={`${cx('message', `${type}Message`, type)} ${dt([
                    'm-0',
                    'mb-4',
                    'font-open-sans',
                    'not-italic',
                    'text-sm',
                ])}`}
            >
                <div
                    className={`${cx('messageBlock', uiType, className)} ${dt([
                        'pb-2.5',
                        'relative',
                        'font-open-sans',
                    ])}`}
                    data-automation-id="message-block"
                >
                    <div className={`${cx('messageGrid')} ${dt(['relative'])}`}>
                        <div
                            className={`${cx('messageIcon')} ${dt([
                                'absolute',
                                'w-6',
                                'top-0',
                                'left-0',
                            ])}`}
                            data-automation-id="message-icon"
                        >
                            <Icon iconType="svg" width="20" height="20" viewBox="0 2 24 24">
                                {messageTypeIconMapping[type]}
                            </Icon>
                        </div>
                        <div
                            className={`${cx('messageContent')} ${dt([
                                'ml-6',
                                'font-open-sans-regular',
                            ])}`}
                        >
                            {title &&
                                (renderAsHTML ? (
                                    <p
                                        className={cx('messageTitle')}
                                        data-automation-id="message-title"
                                        dangerouslySetInnerHTML={{ __html: title }} // eslint-disable-line react/no-danger
                                    />
                                ) : (
                                    <p
                                        className={cx('messageTitle')}
                                        data-automation-id="message-title"
                                    >
                                        {title}
                                    </p>
                                ))}
                            {children && (
                                <div
                                    className={`${cx('messageText')} ${dt([
                                        'text-sm',
                                        'font-open-sans-regular',
                                        'text-black',
                                    ])}`}
                                    data-automation-id="message-content"
                                >
                                    {children}
                                </div>
                            )}
                        </div>
                    </div>
                    {hasClose && (
                        <span className={`${cx('close')} ${dt(['absolute', 'top-0', 'right-0'])}`}>
                            <button data-automation-id="message-close" onClick={this.props.onClose}>
                                <Icon iconType="svg" width="25px" height="25px" viewBox="0 0 25 25">
                                    <Close />
                                </Icon>
                            </button>
                        </span>
                    )}
                </div>
            </div>
        );
    }
}
